import React from 'react';
import { observer } from 'mobx-react';
import { WorksheetStore } from '@seedlang/stores';
import TypeAhead from 'components/type_ahead';
import { isEmpty } from 'lodash';

@observer
class WorksheetSearch extends React.Component {

  static defaultProps = {
    searchByField: 'name',
    placeholder: 'Search for Post',
  };

  componentWillUnmount() {
    this.onClear();
  }

  onKeyUp(value) {
    if (isEmpty(value)) {
      this.onClear();
    } else {
      WorksheetStore.setFilter(this.props.searchByField, `~${value}~`, { refresh: true });
    }
  }

  onSelect(obj) {
    this.props.onSubmit(obj);
  }

  onClear() {
    WorksheetStore.clearIndexData();
    WorksheetStore.clearFilter();
  }

  render() {
    return (
      <div className='concept-search'>
        <TypeAhead
          onKeyUp={this.onKeyUp.bind(this)}
          onSelect={this.onSelect.bind(this)}
          onClear={this.onClear.bind(this)}
          options={WorksheetStore.indexData}
          displayField={this.props.displayField || this.props.searchByField}
          placeholder={this.props.placeholder}
        />
      </div>
    );
  }
}

export default WorksheetSearch;
